import React, { useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import {
  Alert,
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Switch,
} from '@mui/material';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import { UpdateButton } from '../../../components/mui/Buttons/Buttons';
import { useSnackbar } from 'notistack';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { useDispatch } from 'react-redux';
import { getForecastConfig, updateForecastConfig } from '../../../redux/features/feeForecastSlice';
import dayjs from 'dayjs';

const CreateConfig = ({ keyData, val }) => {
  const [addOpen, setAddOpen] = useState(false);
  const [value, setValue] = useState(val || '');
  const { enqueueSnackbar } = useSnackbar();
  const { loading } = useSelector((state) => state.feeForecast);
  const handleApiResponse = useHandleApiResponse();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (!value) {
      return enqueueSnackbar('Please enter the value', {
        variant: 'error',
      });
    }
    const data = { value: value, key: keyData };

    dispatch(updateForecastConfig(data)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setAddOpen(false);
          dispatch(getForecastConfig());
        },
        onFailed: () => {
          console.log('Something went wrong');
        },
      });
    });
  };
  return (
    <GlobalDialog
      open={addOpen}
      setOpen={setAddOpen}
      title={'Update Config'}
      closeButton={true}
      maxWidth={'sm'}
      fullWidth
      popupButton={<UpdateButton size={'small'} action={() => setAddOpen(true)}></UpdateButton>}
      content={
        <Box>
          <TextField
            label="Value"
            value={value}
            placeholder="Enter the value"
            fullWidth
            onChange={(e) => setValue(e.target.value)}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
            <UpdateButton action={handleSubmit}>{loading ? 'Please Wait...' : 'Update Value'}</UpdateButton>
          </Box>
        </Box>
      }
    />
  );
};

const Config = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const [actionLoading, setActionLoading] = useState(false);

  const { forecastConfig } = useSelector((state) => state.feeForecast);

  const handleToggleBoolean = (key, checked) => {
    setActionLoading(true);
    const data = { value: String(checked), key, dataType: 'BOOLEAN' };
    dispatch(updateForecastConfig(data)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          dispatch(getForecastConfig());
        },
        onFailed: () => {
          console.log('Something went wrong');
        },
      });
      setActionLoading(false);
    }).catch((err) => {
      console.error(err);
      setActionLoading(false);
    });
  };

  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={'Config'}
      closeButton={true}
      maxWidth={'lg'}
      fullWidth
      popupButton={
        <Button
          startIcon={<Icon icon="mynaui:config-solid" width="24" height="24" />}
          size="small"
          variant="contained"
          onClick={() => setOpen(true)}
        >
          Config
        </Button>
      }
      content={
        <Box>
          {forecastConfig?.disclaimers?.map((item, i) => {
            return (
              <Alert key={i} severity="info">
                {item}
              </Alert>
            );
          })}

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell>
                    <strong>Description</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Effective Dates</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Value</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {forecastConfig?.configs
                  ?.filter((row) => row.description && row.description.trim() !== '')
                  ?.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell>{row.description}</TableCell>
                      <TableCell>
                        {row.description == 'CRO Dead line Date'
                          ? dayjs(forecastConfig?.effective_dates?.cro).format('DD-MM-YYYY hh:mm A')
                          : row.description == 'CRM Dead line Date'
                            ? dayjs(forecastConfig?.effective_dates.crm).format('DD-MM-YYYY hh:mm A')
                            : row.description == 'Finance Dead line Date'
                              ? dayjs(forecastConfig?.effective_dates?.finance).format('DD-MM-YYYY hh:mm A')
                              : null}
                      </TableCell>
                      <TableCell>
                        {row.data_type === 'BOOLEAN' ? (
                          <Chip
                            label={row.config_value === 'true' || row.config_value === true ? 'Enabled' : 'Disabled'}
                            color={row.config_value === 'true' || row.config_value === true ? 'success' : 'default'}
                            size="small"
                            variant="outlined"
                          />
                        ) : (
                          row.config_value
                        )}
                      </TableCell>
                      <TableCell>
                        {row.data_type === 'BOOLEAN' ? (
                          <Switch
                            checked={row.config_value === 'true' || row.config_value === true}
                            onChange={(e) => handleToggleBoolean(row.config_key, e.target.checked)}
                            disabled={actionLoading}
                          />
                        ) : (
                          <CreateConfig keyData={row.config_key} val={row.config_value} />
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      }
    />
  );
};

export default Config;
